import React, {useContext, useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {ApiContext} from "../../../../api/Api";
import GuestQuestionnaireSelector from "./GuestQuestionnaireSelector";
import useTideTable from "../../../../hooks/table/useTideTable";
import {activeVisitsSGroups, activeVisitsTableColumns} from "../../../../utils/modelUtils/davinci/visitUtils";
import ReactTable from "react-table";

const reqFilters = {
    sGroups: activeVisitsSGroups,
    'order[createdDate]':'DESC',
    'activePersons[gt]':0
};

const ActiveVisits=()=>{
    const api = useContext(ApiContext);
    const questionnaires = useSelector(({api}) => api['ActiveVisits.questionnaires'] || []);
    const guestQuestionnaires = useMemo(() =>
        questionnaires.filter(q =>
            q.isActive && (
                q.config && typeof q.config.availableForGuests === 'boolean'
                    ? q.config.availableForGuests
                    : q.isGcare === true
            )
        ), [questionnaires]);

    useEffect(() => {
        api.questionnaires.get(
            0, 200, undefined,
            {isActive:true, sGroups:['questionnaire_read']},
            'ActiveVisits.questionnaires'
        );
    }, [api]);

    const columns = useMemo(() =>
        activeVisitsTableColumns.map((column) =>
            column.id === 'filledQuestionnaire'
                ? {...column, Cell: ({original}) =>
                    <GuestQuestionnaireSelector visit={original} questionnaires={guestQuestionnaires}/>}
                : column
        ), [guestQuestionnaires]);

    const visitsTable=useTideTable({
        entity:'visits',
        columns: columns,
        requestFilters: reqFilters
    });

    return (
        <div className='ActiveVisits'>
            <ReactTable
                {...visitsTable.tableProps}
            />
        </div>
    );
};

export default ActiveVisits;
